import { IDecodeData, IPrescriptionItem } from 'src/common/interfaces/dtos/IEwic';
import { EpsData, PaymentMessage } from 'src/devices/payment/dtos/eps-data';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { processDecode } from './ewic-decode-prescription';

export const decodeRx = async (
  epsData: EpsData,
  prescriptionData: PaymentMessage,
): Promise<cardRxData> => {
  const { requiresDecodePrescription } = getCurrentXLRConfig();
  if (requiresDecodePrescription && epsData.card.stateCode && prescriptionData.ewicData) {
    const decodeData: IDecodeData = await processDecode({
      stateIdentifierCode: epsData.card.stateCode,
      rawPsData: prescriptionData.ewicData,
      // hard coded rawPsData is for lab use only
      // rawPsData: 'EA01414200200100200EA01414200300100000EA01414200600600200EA01414205200400500EA01414205400200400EA01414201900100700EF00820230622'
    });
    let decodedList: IPrescriptionItem[] = decodeData.prescriptionItems;
    decodedList = decodedList.filter(listItem => !!listItem.unitOfMeasure);
    epsData.card.extendedData = {
      expirationDate: decodeData.expirationDate,
    };
    return {
      prescriptions: decodedList,
      expirationDate: decodeData.expirationDate,
    };
  }
  return {
    prescriptions: [],
    expirationDate: '',
  };
};

export interface cardRxData {
  prescriptions: IPrescriptionItem[];
  expirationDate: string;
}
